import { PAGE_PATHS } from "../core/constants";
import { getAuthContext } from "../config/runtime";
import { localeFromPath, localizedPath, stripViPrefix } from "../core/localePaths";
import { pageFromPath } from "../core/navigation";

const PROTECTED_PAGES = new Set([
  "chinese",
  "coupleMatch",
  "creditsPlans",
  "dashboard",
  "payment",
  "readingHistory",
  "settings",
  "tarot",
  "wedding",
  "western",
]);

/**
 * Prefer the real URL over `window.INITIAL_PAGE`. Stale boot data (e.g. cached HTML or a prior
 * sign-in shell) used to force the wrong SPA page on `/dashboard` and trigger bogus auth redirects.
 */
export function resolveCurrentPage(initialPage, pathname) {
  const path = stripViPrefix(pathname);
  const fromUrl = pageFromPath(pathname);
  const pathIsRoot = path === "/" || path === "";
  if (fromUrl !== "landing" || pathIsRoot) return fromUrl;
  if (initialPage && PAGE_PATHS[initialPage]) return initialPage;
  return "landing";
}

export function resolveRedirectForPage({ currentPage }) {
  const { signedIn, user: authUser } = getAuthContext();
  const user = authUser || {};
  const needsEmailVerification = signedIn && !user.emailVerified && !user.trustedGoogleAccount;
  const locale =
    typeof window !== "undefined" ? localeFromPath(window.location.pathname) : "en";

  if (needsEmailVerification && PROTECTED_PAGES.has(currentPage)) {
    return getPagePath("emailVerificationRequired", locale);
  }
  if (needsEmailVerification && currentPage === "landing") return getPagePath("emailVerificationRequired", locale);
  if (!needsEmailVerification && currentPage === "emailVerificationRequired") return getPagePath("dashboard", locale);
  if (!signedIn && currentPage === "emailVerificationRequired") return getPagePath("login", locale);
  if (signedIn && currentPage === "login") return getPagePath("dashboard", locale);
  if (!signedIn && PROTECTED_PAGES.has(currentPage)) return getPagePath("login", locale);
  if (signedIn && currentPage === "landing") return getPagePath("dashboard", locale);
  const activeSubscription = Boolean(user.activeSubscription ?? user.active_subscription);
  if (signedIn && currentPage === "readingHistory" && !activeSubscription) {
    return getPagePath("creditsPlans", locale);
  }
  return null;
}

export function getPagePath(page, locale) {
  const resolvedLocale = locale || (typeof window !== "undefined" ? localeFromPath(window.location.pathname) : "en");
  return localizedPath(page, resolvedLocale);
}

